const mixin = {
  methods: {
    getColumnName(e) {
      switch (e) {
        case 1: return '首页'
        case 2: return 'MetaEarth价值'
        case 3: return '产品'
        case 4: return '创作奖与惊喜'
        case 5: return '资讯'
        case 6: return '服务'
        case 7: return '招商'
        case 8: return '合作'
        case 9: return 'MetaEarth特殊性'
        case 10: return '我们'
        case 11: return '生态单位'
        case 12: return '学院'
        case 13: return '数字产业圈'
        case 14: return '众包任务'
        case 15: return '加入我们'
      }
    },
    getRegisterId(e) {
      switch (e) {
        case 1: return '规划师'
        case 2: return '规划院'
        case 3: return '设计师'
        case 4: return '设计院'
        case 5: return '入驻元宇宙'
        case 6: return '入驻商户'
        case 7: return '注册数字技术师'
        case 8: return '注册数字技术企业'
        case 9: return '注册公司内部工作'
        case 10: return '注册交流'
      }
    }
  }
}
export default mixin
